export type NewEntryMode =
  | { type: "blank" }
  | { type: "copy"; lbeid: string }
  | { type: "favourite"; favid: string };

export const getNewEntryParams = (mode: NewEntryMode) => {
  switch (mode.type) {
    case "copy":
      return { copyfrom: mode.lbeid };
    case "favourite":
      return { favid: mode.favid };
    default:
      return {};
  }
};

type AnyRecord = Record<string, any>;

const resetEntryDateCells = (node: unknown): unknown => {
  if (Array.isArray(node)) return node.map(resetEntryDateCells);
  if (!node || typeof node !== "object") return node;

  const result: AnyRecord = {};
  Object.entries(node).forEach(([key, value]) => {
    result[key] = resetEntryDateCells(value);
  });
  if (result.id === "entry-date") {
    result.value = "";
    result.now = true;
  }
  return result;
};

const resetSection = (section: AnyRecord): AnyRecord => ({
  ...section,
  rows: (section.rows ?? []).map((row: AnyRecord) => {
    const copy = resetEntryDateCells(row) as AnyRecord;
    delete copy.date;
    delete copy.dateUTC;
    return copy;
  }),
  ...(section.subSections && {
    subSections: section.subSections.map(resetSection),
  }),
  ...(section.sections && { sections: section.sections.map(resetSection) }),
});

export const resetCopiedEntryDates = <T extends { sections?: AnyRecord[] }>(
  lbentry: T,
): T => ({
  ...lbentry,
  sections: (lbentry.sections ?? []).map(resetSection),
});
